import * as s from './selectors';
import * as r from 'ramda';

export const SHOW_PIZZA_CONTAINS_ONLY_DOUGH = 'product-configurator-submit.spd';
export const HIDE_PIZZA_CONTAINS_ONLY_DOUGH = 'product-configurator-submit.hpd';
export const SHOW_PIZZA_CONTAINS_NO_MOZZARELLA =
    'product-configurator-submit.snm';
export const HIDE_PIZZA_CONTAINS_NO_MOZZARELLA =
    'product-configurator-submit.hnm';
export const ADD_MOZZARELLA = 'product-configurator-submit.adm';

export function submit(event) {
    return (dispatch, getState) => {
        event.preventDefault();

        let idMozzarella = s.idMozzarella(getState());

        if (s.isOnlyDoughSelected(getState())) {
            dispatch(showPizzaContainsOnlyDough());
        } else if (
            idMozzarella !== null &&
            s.mozzarellaCount(getState(), idMozzarella) === 0
        ) {
            dispatch(showPizzaContainsNoMozzarella());
        } else {
            dispatch(sendConfiguratorForm());
        }
    };
}

export function showPizzaContainsOnlyDough() {
    return {type: SHOW_PIZZA_CONTAINS_ONLY_DOUGH};
}

export function hidePizzaContainsOnlyDough() {
    return {type: HIDE_PIZZA_CONTAINS_ONLY_DOUGH};
}

export function showPizzaContainsNoMozzarella() {
    return {type: SHOW_PIZZA_CONTAINS_NO_MOZZARELLA};
}

export function hidePizzaContainsNoMozzarella() {
    return {type: HIDE_PIZZA_CONTAINS_NO_MOZZARELLA};
}

export function addMozzarella() {
    return {type: ADD_MOZZARELLA};
}

export function sendConfiguratorForm() {
    return function (dispatch, getState) {
        const state = getState();

        const $form = $('.app-product-adding-to-cart');
        const redirectUrl = r.path(
            ['productConfigurator', 'actions', 'afterSubmit', 'url'],
            state
        );
        const href = $form.attr('action');
        const validationElement = $('#sylius-cart-validation-error');

        $.ajax({
            type: 'POST',
            url: href,
            dataType: 'json',
            data: $form.serialize(),
            error: function (response) {
                const data = $.parseJSON(response.responseText);
                validationElement.removeClass('hidden');
                let validationMessage = '';

                $.each(data.errors.errors, function (key, message) {
                    validationMessage += message;
                });
                const errorBody = $(
                    '<div><div class="pt-6"><button type="button" class="btn btn--primary">' +
                        validationElement.data('ok-label') +
                        '</button></div></div>'
                )
                    .prepend(validationMessage)
                    .html();
                validationElement.html(errorBody);
                validationElement.find('button').one('click', function (e) {
                    validationElement.addClass('hidden');
                });
                $form.removeClass('loading');
            },
            success: function () {
                validationElement.addClass('hidden');
                if (redirectUrl === window.location.href) {
                    window.location.reload();
                } else {
                    window.location.href = redirectUrl;
                }
            },
        });
    };
}
